import type { IconNames } from '@repo/foundations/components/Icon';
import { TablerIconMap } from '@repo/foundations/components/Icon/iconMap';

export type IconEmojiSelectorValue =
	| { iconName: IconNames; iconColor: string }
	| { emoji: string };

export function isEmoji(
	value: IconEmojiSelectorValue
): value is { emoji: string } {
	return typeof value === 'object' && value !== null && 'emoji' in value;
}

export function isTablerIcon(
	value: IconEmojiSelectorValue
): value is { iconName: IconNames; iconColor: string } {
	return typeof value === 'object' && value !== null && 'iconName' in value;
}

export const stringToIconEmojiSelectorValue = (
	value: string
): IconEmojiSelectorValue => {
	if (!value) {
		return { emoji: '💼' };
	}
	if (typeof value === 'string') {
		if (value.startsWith('emoji:')) {
			const emoji = value.split('emoji:')[1];
			return { emoji };
		}
		if (value.startsWith('iconName:')) {
			const iconNameMatch = value.match(/iconName:([^ ]+)/);
			const iconColorMatch = value.match(/iconColor:([^ ]+)/);

			const iconName = iconNameMatch
				? (iconNameMatch[1] as IconNames)
				: 'briefcase';
			const iconColor = iconColorMatch ? iconColorMatch[1] : '#000000';

			// Validate icon exists in registry, fallback to briefcase if not
			const isValidColor =
				typeof iconColor === 'string' && iconColor.trim() !== '';
			const safeIconColor = isValidColor ? iconColor : '#4a4a4a';
			if (!TablerIconMap[iconName]) {
				return { iconName: 'briefcase', iconColor: safeIconColor };
			}

			return { iconName, iconColor: safeIconColor };
		}
		return { emoji: value };
	}
	return { emoji: '💼' };
};

export const iconEmojiSelectorValueToString = (
	value: IconEmojiSelectorValue
): string => {
	if (isEmoji(value)) {
		return `emoji:${value.emoji}`;
	} else {
		return `iconName:${value.iconName} iconColor:${value.iconColor}`;
	}
};
